<template>
  <div>
    <b-modal ref="cancel-game-modal" hide-footer :title="modalTitle">
      <div class="d-flex">
        <b-button class="mt-3 mr-2" variant="primary" block @click="hideCancelGameModal">{{$t('btn.close')}}</b-button>
        <b-button v-if="gameIsActive" class="mt-3" variant="danger" block @click="cancelGame">{{$t('btn.game_cancel')}}</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      gameId: null,
      gameIsActive: true
    }
  },
  computed: {
    modalTitle: function() {
      const title = this.gameIsActive ? this.$t('info.title.are_you_sure_delete_game') : this.$t('info.title.the_game_removed');
      return title;
    }
  },
  methods: {
    showCancelGameModal(data) {
      this.gameId = data;
      this.$refs['cancel-game-modal'].show();
    },
    hideCancelGameModal() {
      this.$refs['cancel-game-modal'].hide();
    },
    cancelGame() {
      axios.delete(`/api/game/${this.gameId}`).then(() => {
        this.gameIsActive = false;

        setTimeout(() => {
          this.$emit('refreshGrid');
        }, 1000);
      });
    }
  }
}
</script>
